"use client";
import { useUIStore } from "@/lib/store";
import { useParams, usePathname } from "next/navigation";
import type { NavRoute } from "@/components/ui/AdminMenu";

export default function ModalLoading() {
  const {
    isLoading,
    loadingMessage,
    loadingMessageClassName,
    loadingMessageStyle,
  } = useUIStore();
  const pathname = usePathname();
  const { ADMIN_ROUTES } = require("@/components/ui/AdminMenu");
  const { USER_ROUTES } = require("@/components/ui/UserMenu");

  const flatAdminRoutes = (ADMIN_ROUTES as NavRoute[]).reduce(
    (acc: NavRoute[], route: NavRoute) => {
      if (route.subRoutes) {
        return [...acc, route, ...route.subRoutes];
      }
      return [...acc, route];
    },
    [] as NavRoute[],
  );

  const routes = [...flatAdminRoutes, ...USER_ROUTES];

  if (!isLoading) return null;

  const label = routes.find((route) => route.path === pathname)?.label;

  return (
    <div
      data-testid="global-loading-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 bg-opacity-20"
    >
      <div className="flex flex-col items-center justify-center p-8 animate-fade-in">
        <div className="w-20 h-20 border-5 border-blue-200 rounded-full border-t-blue-600 animate-spin mb-4"></div>
        <p
          className={
            loadingMessageClassName || "text-white text-2xl w-full text-center"
          }
          style={loadingMessageStyle}
        >
          {loadingMessage || `Cargando ${label ? label.toLowerCase() : ""}...`}
        </p>
      </div>
    </div>
  );
}
